import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, InputGroup, Form, Spinner } from 'react-bootstrap';
import { Utils } from '../../core/utils';
import moment from 'moment';


export default function DGTH_voyage({ searchObj, setSearchObj, total }) {

    /** stati della post */
    const [errors, setErrors] = useState('');
    const [loading, setLoading] = useState(false);

    /** parametri da inviare nel body */
    const [dateFrom, setDateFrom] = useState(null);
    const [dateTo, setDateTo] = useState(null);


    function checkForKey(arr, key) {
        return arr.findIndex(obj => obj.fieldName === key);
    }

    function filterByDate() {
        if (dateFrom && dateTo) {
            var s = Utils.cloneObject(searchObj)
            var c = s.constraints
            var ct = []

            for (var i = 0; i < c.lenght; i++) {
                if (c[i].fieldName !== 'voyageDatetime') {
                    ct.push(c[i])
                }
            }
            ct.push({
                fieldName: 'voyageDateTime',
                type: 'greater',
                value: moment(dateFrom, 'YYYY-MM-DD').format('YYYY-MM-DDT00:00')
            })
            ct.push({
                fieldName: 'voyageDateTime',
                type: 'minor',
                value: (moment(dateTo, 'YYYY-MM-DD').add(1, 'days')).format('YYYY-MM-DDT00:00')
            })

            s.constraints = ct
            setSearchObj(s)
        }
        else {
            setErrors('Seleziona le date per procedere.')
            setTimeout(() => {
                setErrors('')
            }, "3000")
        }
    }

    function filterByCiclo(ciclo) {
        var s = Utils.cloneObject(searchObj)
        var c = s.constraints

        var find = checkForKey(c, 'ciclo')
        if (find !== -1) {
            c[find] = {
                fieldName: 'ciclo',
                type: 'value',
                value: ciclo
            }
        }
        else {
            c.push({
                fieldName: 'ciclo',
                type: 'value',
                value: ciclo
            })
        }

        setSearchObj(s)
    }

    function filterByToday() {
        var s = Utils.cloneObject(searchObj)
        var c = s.constraints
        var ct = []

        for (var i = 0; i<c.length; i++) {
            if (c[i].fieldName !== 'voyageDateTime') {
                ct.push(c[i])
            }
        }
        ct.push({
            fieldName: 'voyageDateTime',
            type: 'greater',
            value: moment().format('YYYY-MM-DDT00:00') //today
        })
        ct.push({
            fieldName: 'voyageDateTime',
            type: 'minor',
            value: (moment().add(1, 'days')).format('YYYY-MM-DDT00:00') //tomorrow
        })

        s.constraints = ct
        setSearchObj(s)
    }

    function filterReset() {
        var s = Utils.cloneObject(searchObj)
        s.constraints = []
        console.warn(s)
        setSearchObj(s)
    }



    return (
        <>
            <Container className='mt-3 mb-3 small align-items-center' fluid>
                <Row>
                    <Col xs={12} md={8}>
                        <Button onClick={() => filterByToday()} size='sm' variant='secondary' className='me-2'>Viaggi di oggi</Button>
                        <Button onClick={() => filterByCiclo('IMPORT')} size='sm' variant='success' className='me-2'>Import</Button>
                        <Button onClick={() => filterByCiclo('EXPORT')} size='sm' variant='primary' className='me-2'>Export</Button>
                        <Button onClick={() => filterReset()} size='sm' variant='danger' className='me-2'>Resetta filtri</Button>
                        <br/>
                        <InputGroup className="mt-2 mb-3" style={{ maxWidth: 500 }}>
                            <Form.Control type="date" onChange={(event) => setDateFrom(event.target.value)} />
                            <Form.Control type="date" onChange={(event) => setDateTo(event.target.value)} />
                            {loading ? (
                                <Button size='md' variant='success' disabled><Spinner /></Button>
                            ) : (
                                <Button size='md' variant='success' onClick={() => filterByDate()}>Filtra per data</Button>
                            )}
                        </InputGroup>
                        {errors && errors.length > 3 ? (
                            <>
                                <p className='small text-danger'>{errors}</p>
                            </>
                        ) : ''}
                    </Col>
                    <Col xs={12} md={4} className='text-end'>
                        Totale viaggi: <b>{total}</b>
                    </Col>
                </Row>


            </Container>
        </>
    )
};